const maintenanceTimelineContent = {
  created: 'Criou a Manutenção.',
  to: 'para',
  from: 'de ',
  empty_value_1: 'nenhum',
  empty_value_2: 'nenhuma',
  change_identifier: 'Mudou o Identificador de',
  change_description: 'Mudou o Descrição de',
  change_value: 'Mudou o Valor de R$',
  change_company: 'Mudou a Empresa Responsável de',
  change_send_to_maintenance_date: 'Mudou a Data Prevista de Envio da Manutenção',
  change_return_from_maintenance_date: 'Mudou a Data Prevista de Retorno da Manutenção',
  change_warranty: 'Mudou o Prazo de Garantia',
  change_expiration: 'Mudou o Prazo de Validade',
  file: 'O arquivo',
  add_file: 'foi adicionado.',
  delete_file: 'foi deletado.',
  change: 'alterou a manutenção.',
};

export default maintenanceTimelineContent;
